module.exports = __webpack_public_path__ + "static/media/2-3-1_OPP_Glossy_01.02012001.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-3-1_OPP_Glossy_01.jpg
// module id = 1719
// module chunks = 0